export const getSignificantItems = <
  T extends { share: number; isSignificant: boolean },
>(
  data: T[],
  maxCount?: number
): T[] => {
  const significantItems = data
    .filter((item) => item.isSignificant)
    .sort((a, b) => b.share - a.share);

  return maxCount ? significantItems.slice(0, maxCount) : significantItems;
};

export const getTopSignificantItem = <
  T extends { share: number; isSignificant: boolean },
>(
  data: T[]
): T | undefined => {
  return getSignificantItems(data, 1)[0];
};
